import { useState, forwardRef, useRef } from 'react';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { useUserAccess, SubSection } from '@ui-framework/index';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useFormContext } from 'react-hook-form';
import { NOTE_ACTION } from '@constants/notesAttachment';
import SentimentAnalysis from '../../ArtificalIntelligence/SentimentAnalysis';
import AiChat from '../../ArtificalIntelligence/AiChat';
import NotesList from './NotesList';
import IconLibrary from '../../IconLibrary';
import NoteDetailModal from './NoteDetailModal';
import { useServiceModule } from '../../ServiceModuleProvider';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

const NotesAttachment = forwardRef((props, ref) => {
  const { getValues } = useFormContext();
  const noteListRef = useRef(null);
  const noteModalRef = useRef(null);
  const userAccess = useUserAccess();
  const serviceJobData = getValues();
  const { moduleSettings } = useServiceModule();

  const [tabNumber, setTabNumber] = useState(0);

  const handleChange = (event, newValue) => {
    if (newValue < 2) {
      setTabNumber(newValue);
    }
  };

  const compactTabSx = {
    minHeight: 36,
    minWidth: 'auto',
    paddingBottom: 0.5,
  };

  const hasSentimentAnalysis =
    (userAccess.isSA() || userAccess.isAdmin()) &&
    moduleSettings?.insightPurchased &&
    serviceJobData?.serviceJobStatus !== 'INCOMPLETE';

  const readOnlyRole = userAccess?.role?.roleIdentifier === 'READONLY';

  return (
    <Box ref={ref}>
      {hasSentimentAnalysis && (
        <Box>
          <SentimentAnalysis serviceJob={serviceJobData} />
        </Box>
      )}

      <SubSection sx={{ mt: 2 }}>
        <Grid2 container sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Grid2 xs={9}>
            <Tabs value={tabNumber} onChange={handleChange}>
              <Tab
                sx={compactTabSx}
                icon={<IconLibrary.Note />}
                iconPosition="start"
                label="Notes"
                id="simple-tabpanel-0"
              />
              {hasSentimentAnalysis && (
                <Tab
                  sx={compactTabSx}
                  icon={<IconLibrary.Conversation />}
                  iconPosition="start"
                  label="Conversations"
                  id="simple-tabpanel-1"
                />
              )}
            </Tabs>
          </Grid2>
          <Grid2 xs={3}>
            {!readOnlyRole && (
              <Box sx={{ textAlign: 'right', mt: 1 }}>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<IconLibrary.Note />}
                  onClick={() => {
                    noteModalRef?.current?.open({
                      note: null,
                      canEdit: true,
                      title: 'Add Note',
                      action: NOTE_ACTION.ADD,
                    });
                  }}>
                  Add Note
                </Button>
              </Box>
            )}
          </Grid2>
        </Grid2>

        <CustomTabPanel value={tabNumber} index={0}>
          <NotesList
            ref={noteListRef}
            noteModalRef={noteModalRef}
            readOnlyRole={readOnlyRole}
          />
        </CustomTabPanel>
        {hasSentimentAnalysis && (
          <CustomTabPanel value={tabNumber} index={1}>
            <AiChat serviceJobData={serviceJobData} />
          </CustomTabPanel>
        )}
      </SubSection>
      <NoteDetailModal
        readOnlyRole={readOnlyRole}
        noteListRef={noteListRef}
        serviceJobId={serviceJobData?.id}
        ref={noteModalRef}
      />
    </Box>
  );
});

export default NotesAttachment;
